import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { LinkViewComponent } from '../../../shared/components/public/linkview.component';
import { Repository } from '../../../services/repository'
import { LocalDataSource } from 'ng2-smart-table';
import 'jquery'
import 'bootstrap'
import { Observable } from 'rxjs';
import { retry } from 'rxjs-compat/operator/retry';
const swal = require('sweetalert');
@Component({
  selector: 'app-tonghop-chontaikhoanedit',
  templateUrl: './chontaikhoanedit.component.html',   
    providers: [ListService, Repository]
})


export class chontaikhoaneditComponent implements OnInit {

  @Input() DeNghi: number;
  @Output() savect: EventEmitter<any> = new EventEmitter();
  source: LocalDataSource;
  inputDanhHieus: any;
 
  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  phanheid: any;
  settings = {
    mode: 'external',
    
    attr: {
      class: 'table table-striped table-bordered table-hover'
    },
    pager: {
      perPage: 1,
      display: false,
    },
    actions: {

      add: false,
      edit: false,
      delete: false,

      position: 'right',
    },
    columns: {

      UserName: {
        name: 'UserName',
        width: '200px',
        title: 'Tài khoản',
        type: 'custom',
        renderComponent: LinkViewComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => {
            console.log(row);
            this.saveproduct(row);
          });
        }
      },
      DisplayName: {
        name: 'DisplayName',
        title: 'Họ tên',
        type: 'custom',
        renderComponent: LinkViewComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => {
            console.log(row);
            this.saveproduct(row);
          });
        }
      },
      Email: {
        name: 'Email',
        title: 'Hòm thư',
        type: 'custom',
        renderComponent: LinkViewComponent,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(row => {
            console.log(row);
            this.saveproduct(row);
          });
        }
      },
    },
  };
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {

    this.source = new LocalDataSource();

  }

  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  
  loadDataInit(id: string, pheid: string) {  
   
    //this.repo.getRequest("api/hoso/hinhthuclist/", { loai: 0, danhhieu: 1 })
    //  .subscribe(response => {
    //    this.inputDanhHieus = response;
    //  });
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
    
      this.repo.getRequest("api/user/getgan/", { username: this.username})
        .subscribe(response => {
          console.log(response);
          this.source.load(response);
        }); 
    }
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }
   
  }
  selectedRows: any;
  onRowSelect(event) {
    this.selectedRows = event.selected;
  }
  public closeModal() {
    this.savect.emit(null);
  }
  danhhieudangky: any;
  public saveproduct(row) {
    //if (this.DeNghi === undefined && (this.danhhieudangky == null || this.danhhieudangky == "")) {
    //  swal('Lỗi!', 'Vui lòng chọn danh hiệu đăng ký.', 'error');
    //  return;
    //}

    console.log(row);

    this.savect.emit(row);

  }

}
